import { productImpression } from "./productImpression";
import { experimentViewed } from "./experimentViewed";

export const handlers = {
  productImpression,
  experimentViewed
};
